/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

"use client";

import { VStack } from "@panda/jsx";

import type { SearchSectionProps } from "./Search.section";

type SearchLoadingProps = Pick<SearchSectionProps, "loadingComponent" | "loadingLabel">;

export const SearchLoading = ({ loadingComponent, loadingLabel }: SearchLoadingProps): React.JSX.Element | null => {
	return (
		<VStack maxHeight="30vh" maxWidth="full" overflow="hidden" justifyContent="center">
			{loadingComponent || loadingLabel || ""}
		</VStack>
	);
};
